var _rect, _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _circle4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLowLevelDesign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "#4659CA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9169 8.00002C28.9169 7.03351 29.7004 6.25 30.6669 6.25H33.7502V13.75H30.6669C29.7004 13.75 28.9169 12.9665 28.9169 12V8.00002Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.500006
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.917 18C28.917 17.0335 29.7005 16.25 30.667 16.25H33.7503V23.75H30.667C29.7005 23.75 28.917 22.9665 28.917 22V18Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.500006
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9169 28C28.9169 27.0335 29.7004 26.25 30.6669 26.25H33.7502V33.75H30.6669C29.7004 33.75 28.9169 32.9665 28.9169 32V28Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.500006
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3335 10C21.8335 10 19.8335 10 19.8335 10V20M19.8335 20V30H22.3335M19.8335 20H22.3335",
    stroke: "white",
    strokeWidth: 0.7
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.9984,
    cy: 10,
    r: 1.75,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.500006
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.9984,
    cy: 20,
    r: 1.75,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.500006
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 20,
    r: 1.75,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.500006
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.9984,
    cy: 30,
    r: 1.75,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.500006
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8335 20H17.0001",
    stroke: "white",
    strokeWidth: 0.7
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3333 20H9.5",
    stroke: "white",
    strokeWidth: 0.7
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2495 18C12.2495 17.0335 13.033 16.25 13.9995 16.25H17.0828V23.75H13.9995C13.033 23.75 12.2495 22.9665 12.2495 22V18Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.500006
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowLevelDesign);
export default __webpack_public_path__ + "static/media/lowLevelDesign.8a105a7c80826d41b749138e32df2ad4.svg";
export { ForwardRef as ReactComponent };